import { render, staticRenderFns } from "./GeneralArticles.vue?vue&type=template&id=a6f93946"
import script from "./GeneralArticles.vue?vue&type=script&lang=js"
export * from "./GeneralArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports